import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Venda } from 'src/app/shared/classes/productvenda';
import { Produto } from 'src/app/shared/classes/produto';
import { CancelarVendaComponent } from 'src/app/shared/components/modal/cancelarvenda/cancelarvenda.component';
import { EnviarEmailComponent } from 'src/app/shared/components/modal/enviaremail/enviaremail.component';
import { PassageiroComponent } from 'src/app/shared/components/modal/passageiro/passageiro.component';
import { VendaCadastradaComponent } from 'src/app/shared/components/modal/vendacadastrada/vendacadastrada.component';
import { ProdutoService } from 'src/app/shared/services/produto.service ';
import { ProdutoVendaService } from 'src/app/shared/services/produtovenda.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { VendaService } from 'src/app/shared/services/venda.service';
import { STORAGE_KEYS } from 'src/config/storage_keys.config';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  providers: [
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ],
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('spin', [
      transition('* => *', [
        animate('2s linear', keyframes([
          style({ transform: 'translate(44%)    rotateY(0deg)', offset: 0 }),
          style({ transform: 'translate(44%)   rotateY(13deg)', offset: 0.25 }),
          style({ transform: 'translate(44%)  rotateY(20deg)', offset: 0.50 }),
          style({ transform: 'translate(44%)  rotateY(13deg)', offset: 0.75 }),
          style({ transform: 'translate(44%) ', offset: 1.0 })
        ]))
      ])
    ])
  ],
  styles: [
    `
			.custom-day {
				text-align: center;
				padding: 0.185rem 0.25rem;
				border-radius: 0.25rem;
				display: inline-block;
				width: 2rem;
			}
			.custom-day:hover,
			.custom-day.focused {
				background-color: #e6e6e6;
			}
			.weekend {
				background-color: #c3e8ff;
				border-radius: 0.75rem;
				color: black;
			}
			.hidden {
				display: none;
			}
      .qudroqtd {
        /* border: 1px solid blue;  */
        padding-top: 15px;
      }
      .subtotalqtd {
        padding-left: 15px;
      }
      .totalcalculo {
        padding-top: 15px;
      }
		`,
  ],
})

export class DashboardComponent implements OnInit {
  //@ViewChild("vendacadastrada") Passageiro: VendaCadastradaComponent;
  @ViewChild("passageiro") Passageiro: VendaCadastradaComponent;
  @ViewChild("cancelarVenda") CancelarVenda: CancelarVendaComponent;
  @ViewChild("enviarEmail") EnviarEmail: EnviarEmailComponent;
  @ViewChild('esperaModal', { static: false }) esperaModal;

  public openDashboard: boolean = false;
  public checkoutForm: UntypedFormGroup;
  public tipoFiltro = "emissao";

  public linkToCopy = "";

  statusItems = ["Ativo", "Inativo", "Operação realizada com sucesso"];
  produtosBase: Produto[] = [];
  vendasBase: Venda[] = [];
  vendasInicio: Venda[] = [];

  dataInicialModel;
  dataFinalModel;
  statusSelected = "";
  produtoSelected = 0;
  productVenda;
  vendaSelected;
  usuario;
  passageironome = "";
  idvendapesquisa = 0;

  idVenda;
  idComprovante;

  tipoAcao: any;

  idUsuario = JSON.parse(localStorage.getItem(STORAGE_KEYS.localUser)).id;

  spinState = 'start';

  constructor(
    private fb: UntypedFormBuilder,
    public produtoService: ProdutoService,
    public vendaService: VendaService,
    public usuarioService: UsuarioService,
    private produtoVendidoServico: ProdutoVendaService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
  ) {
    this.checkoutForm = this.fb.group({
      produto: [],
      dataInicial: ['', Validators.required],
      dataFinal: ['', Validators.required],
      status: [],
      passageironome: [],
      idvendapesquisa: []
    })
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.getProdutos();
    this.getVendas();
    this.getUsuario();
    this.loopAnimation();
  }

  loopAnimation() {
    setInterval(() => {
      this.spinState = this.spinState === 'start' ? 'stop' : 'start';
    }, 2000); // Repetir a cada 2 segundos para simular "infinite"
  }

  espera() {
    this.modalService.open(this.esperaModal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static'
    });
  }

  fecharEspera() {
    this.modalService.dismissAll();
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  getProdutos() {
    this.produtoService.getProdutos().subscribe(data => {
      this.produtosBase = data;
      let produ = new Produto();
      produ.nome = "- Todos";
      this.produtoSelected = produ.id;
      this.produtosBase.push(produ);
      this.produtosBase.sort((a, b) => a.nome.localeCompare(b.nome));
    })
  }

  getUsuario() {
    this.usuarioService.getUsuarioById(this.idUsuario).subscribe(data => {
      this.usuario = data;
    })
  }

  getVendas() {
    this.vendaService.getVendas().subscribe(data => {
      this.vendasInicio = data;
      this.statusItems = [];
      this.vendasInicio.map((venda) => {
        this.statusItems.push(venda.status)
        this.statusItems = [...new Set(this.statusItems.map((item) => item))];
      })
    })
  }

  faturado(venda) {
    venda.status = "Faturado";
    venda.usuario.perfis = venda.usuario.perfisGeral;
    this.vendaService.putVenda(venda, venda.id).subscribe(
      data => {
        console.log(data)
      }
    )
  }

  cancelar(venda) {
    this.CancelarVenda.openModal("carrinho")
    venda.usuario.perfis = venda.usuario.perfisGeral;
    this.vendaSelected = venda;
  }

  copiarlink(venda) {
    this.linkToCopy = "https://www.tourregular.com.br/tourregular/#/pagamento/linkpagamento/" + venda.id.toString();
    const textarea = document.createElement('textarea');
    textarea.value = this.linkToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    // this.toastrService.success('Link copiado para a área de transferência!', 'OK!', {
    //   timeOut: 7000, progressBar: true, progressAnimation: 'increasing',
    // });
    alert('Link copiado para a área de transferência!')

  }

  enviarEmailModal(venda, tipo, idProd) {
    this.EnviarEmail.openModal(tipo, idProd)
    venda.usuario.perfis = venda.usuario.perfisGeral;
    this.vendaSelected = venda;
  }

  onSubmit() {
    this.espera();
    var dataIni;
    if (this.dataInicialModel != null) {
      dataIni = new Date(this.dataInicialModel.year, this.dataInicialModel.month - 1, this.dataInicialModel.day);
    } else {
      dataIni = null;
    }

    var dataFim;
    if (this.dataFinalModel != null) {
      dataFim = new Date(this.dataFinalModel.year, this.dataFinalModel.month - 1, this.dataFinalModel.day);
    } else {
      dataFim = null;
    }

    if (this.tipoFiltro == "emissao" || this.tipoFiltro == "tour") {
      var mesInicial = this.dataInicialModel.getMonth() + 1;
      if (mesInicial < 10) {
        mesInicial = "0" + mesInicial;
      }

      var diaInicial = this.dataInicialModel.getDate();
      if (diaInicial < 10) {
        diaInicial = "0" + diaInicial;
      }
      dataIni = this.dataInicialModel.getFullYear() + "-" + mesInicial + "-" + diaInicial;
    }

    if (this.tipoFiltro == "emissao") {
      var mesFinal = this.dataFinalModel.getMonth() + 1;
      if (mesFinal < 10) {
        mesFinal = "0" + mesFinal;
      }

      var diaFinal = this.dataFinalModel.getDate();
      if (diaFinal < 10) {
        diaFinal = "0" + diaFinal;
      }
      dataFim = this.dataFinalModel.getFullYear() + "-" + mesFinal + "-" + diaFinal;
    }

    var diaAtual = 3;
    if (this.produtoSelected == null) {
      this.produtoSelected = 0;
    }

    if (this.tipoFiltro == "emissao") {
      this.vendaService.getVendasAgenciaEmissao(this.usuario.cliente.id, this.produtoSelected, this.statusSelected, dataIni, dataFim).subscribe(data => {
        this.vendasBase = data;
        this.vendasBase.forEach(venda => {
          diaAtual = 3;
          venda.produtosVendidos.forEach(prod => {
            var dia = (new Date(prod.tarifa.data.data).getTime() - new Date().getTime()) / 86400000;
            if (diaAtual > dia) {
              diaAtual = dia
            }
            venda.diasAntesDeExecutar = diaAtual;
          })
        });
        this.fecharEspera();
      })
    }
    if (this.tipoFiltro == "tour") {
      this.vendaService.getVendasAgenciaTour(this.usuario.cliente.id, this.produtoSelected, this.statusSelected, dataIni).subscribe(data => {
        this.vendasBase = data;
        this.vendasBase.forEach(venda => {
          diaAtual = 3;
          venda.produtosVendidos.forEach(prod => {
            var dia = (new Date(prod.tarifa.data.data).getTime() - new Date().getTime()) / 86400000;
            if (diaAtual > dia) {
              diaAtual = dia
            }
            venda.diasAntesDeExecutar = diaAtual;
          })
        });
        this.fecharEspera();
      })
    }

    if (this.tipoFiltro == "passageiro") {
      this.vendaService.getVendasAgenciaPassageiro(this.usuario.cliente.id, this.passageironome).subscribe(data => {
        this.vendasBase = data;
        this.vendasBase.forEach(venda => {
          diaAtual = 3;
          venda.produtosVendidos.forEach(prod => {
            var dia = (new Date(prod.tarifa.data.data).getTime() - new Date().getTime()) / 86400000;
            if (diaAtual > dia) {
              diaAtual = dia
            }
            venda.diasAntesDeExecutar = diaAtual;
          })
        });
        this.fecharEspera();
      })
    }

    if (this.tipoFiltro == "idvendapesquisa") {
      this.vendaService.getVendasAgenciaVenda(this.usuario.cliente.id, this.idvendapesquisa).subscribe(data => {
        this.vendasBase = data;
        this.vendasBase.forEach(venda => {
          diaAtual = 3;
          venda.produtosVendidos.forEach(prod => {
            var dia = (new Date(prod.tarifa.data.data).getTime() - new Date().getTime()) / 86400000;
            if (diaAtual > dia) {
              diaAtual = dia
            }
            venda.diasAntesDeExecutar = diaAtual;
          })
        });
        this.fecharEspera();
      })
    }
  }

  imprimirComprovante(idVenda) {
    this.espera();
    this.vendaService.getComprovante(idVenda).subscribe(
      response => {
        this.saveFile(response);
        this.fecharEspera();
      }
    )
  }

  imprimirVoucher(idProdutoVendido) {
    this.espera();
    this.produtoVendidoServico.getVoucher(idProdutoVendido).subscribe(
      response => {
        this.saveFile(response);
        this.fecharEspera();
      }
    )
  }

  saveFile(data: any) {
    const blob = new Blob([data], { type: data.type });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }
}
